// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'leaf';

export const Component = () => (
  <path d='M24.426 2.24a.503.503 0 0 0-.431-.24c-7.52.048-13.362 1.82-17.53 5.316C2.252 10.813.097 16.033 0 23.073c0 .336.191.48.527.48 7.52-.048 13.361-1.82 17.576-5.317 4.167-3.449 6.322-8.669 6.418-15.709 0-.047-.048-.143-.096-.287Zm-2.395.814h.048C17.816 5.4 13.985 7.987 10.584 10.86L9.77 6.263c3.832-2.06 7.903-3.114 12.261-3.21ZM8.91 6.79l.91 4.694c-3.4 2.778-6.274 5.89-8.62 9.386.43-6.37 3.017-11.063 7.71-14.08ZM1.342 22.595c.91-1.82 2.156-3.544 3.688-5.173l10.058 1.724c-3.544 2.156-8.142 3.305-13.746 3.449Zm14.99-4.311-.048.047L5.796 16.56c2.586-2.634 5.22-4.98 7.95-6.992l8.094 1.868c-1.293 2.874-3.113 5.173-5.508 6.849Zm5.795-7.615.048-.192-7.232-1.82c2.682-2.01 5.412-3.735 8.237-5.123.24 2.155-.143 4.55-1.053 7.136v-.001Z' />
);

export const viewBox = '0 0 25 25';
